module.exports = __webpack_public_path__ + "static/media/sun-riseaura-PH1_bg.dd426570.webp";